import { getPaddingsClassFromData } from "@/utils/utils"
import styled from "styled-components"
import Section from "@/components/TeamModule/Section"
import React, { useCallback, useState } from "react"

const StyledWrapper = styled.section``

export default function TeamModule({ data }) {
	const paddings = getPaddingsClassFromData(data)
	const sections = data?.sections || []
	// eslint-disable-next-line no-unused-vars
	const [modalOpen, setModalOpen] = useState(false)
	// eslint-disable-next-line no-unused-vars
	const [modalData, setModalData] = useState(null)

	const handleSetModalData = useCallback(
		(sectionIndex, memberIndex) => {
			setModalOpen(true)

			const currentSection = sections[sectionIndex] || null
			const currentMember = sections[sectionIndex]?.items[memberIndex] || null

			setModalData({
				sectionIndex,
				currentSection,
				memberIndex,
				currentMember,
			})
		},
		[sections],
	)

	return (
		<StyledWrapper className={paddings}>
			{sections.map((section, index) => {
				const id = section?.id || index
				return <Section key={id} sectionIndex={index} section={section} handleSetModalData={handleSetModalData} />
			})}
		</StyledWrapper>
	)
}
